"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorState = void 0;
const enums_1 = require("../enums");
class ActorState {
    constructor(id, classType, faction, level, initialAttributes, abilities, equipment, archetypeNames, rarity = enums_1.Rarity.Common, playerId = undefined, characterId = undefined, characterXp = 0, characterXpToLevel = 0) {
        this.id = id;
        this.classType = classType;
        this.faction = faction;
        this.level = level;
        this.abilities = abilities;
        this.equipment = equipment;
        this.archetypeNames = archetypeNames;
        this.rarity = rarity;
        this.playerId = playerId;
        this.characterId = characterId;
        this.characterXp = characterXp;
        this.characterXpToLevel = characterXpToLevel;
        this.baseAttributeValues = {};
        this.attributeValues = {};
        this.maxAttributeValues = {};
        this.effects = {};
        this.eventHandlers = {};
        this.ownerId = 0;
        this.companionIds = [];
        this.actionsTaken = 0;
        this.turnCount = 0;
        this.lastAttackedBy = 0;
        this.locals = {};
        this.permanents = {};
        this.maxAttributeValues = { ...initialAttributes };
        this.attributeValues = { ...this.maxAttributeValues };
        this.baseAttributeValues = { ...this.maxAttributeValues };
    }
}
exports.ActorState = ActorState;
